import { render, staticRenderFns } from "./SearchDashboardProjectBar.vue?vue&type=template&id=5d3373e3&"
import script from "./SearchDashboardProjectBar.vue?vue&type=script&lang=ts&"
export * from "./SearchDashboardProjectBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports